import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, TextField } from "@mui/material";
import { DateTimePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import moment from "moment";

const LoginStreakDateDialog = ({ open, onClose, loginStreakDates, handleDateChange, updateLoginStreakDatesHandler }) => {
	return (
		<Dialog open={open} onClose={onClose} aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description">
			<DialogTitle id="alert-dialog-title">Update Dates</DialogTitle>
			<DialogContent>
				<Grid container>
					<Grid item xs={12} sx={{ m: 0, p: 1 }}>
						<LocalizationProvider dateAdapter={AdapterMoment}>
							<DateTimePicker
								label="Login Streak Start"
								value={moment(loginStreakDates.loginStreakStartDate)}
								onChange={(value) => handleDateChange(value, "loginStreakStartDate")}
								renderInput={(params) => <TextField {...params} />}
							/>
						</LocalizationProvider>
					</Grid>
					<Grid item xs={12} sx={{ m: 0, p: 1 }}>
						<LocalizationProvider dateAdapter={AdapterMoment}>
							<DateTimePicker
								label="Last Login"
								value={moment(loginStreakDates.lastLoginDate)}
								onChange={(value) => handleDateChange(value, "lastLoginDate")}
								renderInput={(params) => <TextField {...params} />}
							/>
						</LocalizationProvider>
					</Grid>
				</Grid>
			</DialogContent>
			<DialogActions>
				<Button onClick={onClose}>Cancel</Button>
				<Button onClick={updateLoginStreakDatesHandler} autoFocus>
					Update
				</Button>
			</DialogActions>
		</Dialog>
	);
};

export default LoginStreakDateDialog;
